<template>
<StdPageContainer type="list">
  <template slot="title">
    <!-- NOTE: 标题栏: 开发人员根据业务调整 -->
    <StdPageTitle :title="$t('lang.k_218001')">
      <div slot="content">{{ $t('lang.k_218002') }}</div>
    </StdPageTitle>
  </template>

  <!-- 内容区 -->
  <template slot="content">
    <!-- 这块内容在 无Tab 和 有tab 页面都使用，所有单独抽离-->
    <ReceiptDetails
      style="min-height: 600px"
      source="admin"
      :rewardId="$route.params.reward_id"
      :webinarId="$route.params.id"
    />
  </template>
</StdPageContainer>
</template>

<script>

import { StdPageContainer, StdPageTitle } from '@vhcl/ui-console';
import { ReceiptDetails } from '@vhcl/mall-rewards';
export default {
  components: {
    ReceiptDetails
  },
  methods: {
    handleSearch() {}
  }
};
</script>
